(function () {
  const config = window.gymProtection;
  if (!config || !config.protected) {
    return;
  }

  const gateEl = document.getElementById(config.gateId);
  if (!gateEl) {
    return;
  }

  const contentEl = config.contentId
    ? document.getElementById(config.contentId)
    : null;

  const storageKey = config.storageKey;
  const expiryHours = Number(config.expiryHours) || 24;
  const errorEl = gateEl.querySelector('[data-gym-error]');
  const formEl = gateEl.querySelector('form[data-gym-form]');
  const inputEl = gateEl.querySelector('input[name="password"]');

  const now = Date.now();
  const passwordFingerprint = createPasswordFingerprint(config.password);

  function createPasswordFingerprint(value) {
    if (!value) return '';
    let hash = 0;
    for (let i = 0; i < value.length; i += 1) {
      hash = (hash << 5) - hash + value.charCodeAt(i);
      hash |= 0;
    }
    return hash.toString(36);
  }

  function readStoredState() {
    if (!storageKey || !window.localStorage) return null;
    try {
      const stored = window.localStorage.getItem(storageKey);
      if (!stored) return null;
      const parsed = JSON.parse(stored);
      if (passwordFingerprint && parsed.passwordFingerprint !== passwordFingerprint) {
        window.localStorage.removeItem(storageKey);
        return null;
      }
      return parsed;
    } catch (error) {
      console.error('Unable to read gym protection state:', error);
      return null;
    }
  }

  function writeStoredState() {
    if (!storageKey || !window.localStorage) return;
    const expiresAt = new Date(now + expiryHours * 60 * 60 * 1000).toISOString();
    try {
      window.localStorage.setItem(
        storageKey,
        JSON.stringify({ unlocked: true, expiresAt, passwordFingerprint })
      );
    } catch (error) {
      console.error('Unable to persist gym protection state:', error);
    }
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function getFollowingPageSections() {
    if (!config.protectFollowingSections) return [];
    const heroSection = gateEl.closest('.shopify-section');
    if (!heroSection) return [];

    const sections = [];
    let sibling = heroSection.nextElementSibling;
    while (sibling) {
      if (sibling.classList && sibling.classList.contains('shopify-section')) {
        sections.push(sibling);
      }
      sibling = sibling.nextElementSibling;
    }
    return sections;
  }

  function getRevealElements() {
    return document.querySelectorAll('[data-gym-reveal]');
  }

  function setElementsHidden(elements, hidden) {
    elements.forEach((el) => {
      el.hidden = hidden;
    });
  }

  function setPageLocked(locked) {
    document.documentElement.classList.toggle('gym-page-locked', locked);
    document.documentElement.classList.toggle('gym-page-unlocked', !locked);

    const followingSections = getFollowingPageSections();
    setElementsHidden(followingSections, locked);

    if (contentEl) {
      contentEl.hidden = locked;
    }

    setElementsHidden(getRevealElements(), locked);

    gateEl.hidden = !locked;
  }

  function revealContent() {
    clearError();
    setPageLocked(false);
    document.dispatchEvent(
      new CustomEvent('gym-protection:unlocked', {
        detail: { contentId: config.contentId, gateId: config.gateId },
      })
    );
  }

  function ensureGateVisible() {
    setPageLocked(true);
  }

  const storedState = readStoredState();
  if (storedState && storedState.unlocked && storedState.expiresAt) {
    const expiresAt = Date.parse(storedState.expiresAt);
    if (!Number.isNaN(expiresAt) && expiresAt > now) {
      revealContent();
      return;
    }
    if (window.localStorage) {
      try {
        window.localStorage.removeItem(storageKey);
      } catch (error) {
        console.error('Unable to clear expired gym protection state:', error);
      }
    }
  }

  ensureGateVisible();

  if (!formEl || !inputEl) {
    return;
  }

  formEl.addEventListener('submit', (event) => {
    event.preventDefault();
    clearError();

    const entered = inputEl.value || '';
    if (!entered) {
      showError('Please enter the access code.');
      return;
    }

    if (entered !== config.password) {
      showError('Incorrect code. Please try again.');
      return;
    }

    writeStoredState();
    revealContent();
  });
})();
